import { LOCATION_CHANGE } from 'connected-react-router';
import { produce } from 'immer';
import _ from 'lodash';
import {
    REGISTRATION_PREPARE_MOBILE_ACTION,
    REGISTRATION_START_MOBILE_ACTION,
} from '../mobileAppCore/mobileAppConstants';
import {
    CHECK_CODE_FAILURE,
    CHECK_CODE_START,
    CHECK_CODE_SUCCESS,
    CREATE_PASSWORD_FAILURE,
    CREATE_PASSWORD_START,
    CREATE_PASSWORD_SUCCESS,
    LOGIN_FAILURE,
    LOGIN_START,
    LOGIN_SUCCESS,
    LOGIN_WITH_TELEGRAM_START,
    LOGIN_WITH_TELEGRAM_STOP,
    LOGOUT_SUCCESS,
    PASSWORD_RESET_FAILURE,
    PASSWORD_RESET_RESET,
    PASSWORD_RESET_START,
    PASSWORD_RESET_SUCCESS,
    PASSWORD_UPDATE_FAILURE,
    PASSWORD_UPDATE_START,
    PASSWORD_UPDATE_SUCCESS,
    REGISTRATION_FAILURE,
    REGISTRATION_START,
    REGISTRATION_SUCCESS,
    SET_CHANGE_EMAIL_SUCCESS,
    SET_REGISTRATION_DATA,
} from '../modules/Login/loginConstants';

import {
    ADD_AB_TEST_TO_IS_USED_QUEUE,
    APP_INIT_FAILURE,
    APP_INIT_START,
    APP_INIT_SUCCESS,
    CLOSE_MODAL,
    COMPLETE_LEADERBOARD_ONBOARDING_SUCCESS,
    COMPLETE_ONBOARDING_FAILURE,
    COMPLETE_ONBOARDING_START,
    COMPLETE_ONBOARDING_SUCCESS,
    DELETE_PROFILE_FAILURE,
    DELETE_PROFILE_START,
    DELETE_PROFILE_SUCCESS,
    LOAD_ACCOUNT_TRADE_INFO_FAILURE,
    LOAD_ACCOUNT_TRADE_INFO_START,
    LOAD_ACCOUNT_TRADE_INFO_SUCCESS,
    LOCALE_CODES,
    OPEN_MODAL,
    RESET_FORM_ERROR,
    SEND_REQUEST_FEEDBACK_FAILURE,
    SEND_REQUEST_FEEDBACK_START,
    SET_APP_INIT_DATA,
    SET_IS_FIRST_LOGIN,
    SET_IS_OPEN_MOBILE_APP_BANNER_VISIBLE,
    SET_LANG_DATA_ACTION,
    SET_REQUEST_FEEDBACK,
    SET_USER_SELECTED_ACCOUNT_CODE,
    SET_ZENDESK_CONFIG_ACTION,
    TOGGLE_IS_ONE_CLICK_TRADING_ON,
    UPDATE_AB_TEST_IS_USED_START,
    UPDATE_ACCOUNT_ACTION,
    USER_UPDATE_PASSWORD_FAILURE,
    USER_UPDATE_PASSWORD_START,
    USER_UPDATE_SUCCESS,
    USER_UPDATE_USERNAME_CLEAR,
    USER_UPDATE_USERNAME_FAILURE,
    USER_UPDATE_USERNAME_START,
    USER_UPDATE_USERNAME_SUCCESS,
} from './appConstants';
import type { IAppState, IFullAppActyonTypes } from './types/appReducer.t';
import { getSystemLocale } from './appUtils';
import { ZENDESK_WEB_WIDGET_TYPES } from "../modules/Zendesk/zendeskConstants";
import { USER_STATUSES_NAMES } from "../modules/UserStatus/userStatusesConstants";
import Cookies from "universal-cookie";
import { USER_STATE_NAMES } from "../modules/UserStateInformation/UserState.t";
import { IUsernameSuggestionFailurePayload } from "./types/appActions.t";

const cookies = new Cookies();

const initialState: IAppState = {
    appMode: cookies.get('app_mode') || 'web',
    inited: false,
    lang: null,
    visibility: true,

    loggedIn: false,
    loggedInProcess: false,

    formError: '',
    passwordResetSent: false,
    user: {
        accounts: [],
        auth_by: '',
        accept_policy_at: '',
        buyer: false,
        country: '',
        defaultAccountCode: '',
        email: '',
        email_confirmed: false,
        locale: getSystemLocale(),
        leaderboardOnboardingPassed: false,
        payment_account_code: '',
        payment_data_id: null,
        provider_deposit: 0,
        provider_payout: 0,
        recents: {},
        state: USER_STATE_NAMES.ACTIVE,
        state_reason_code: '',
        uid: 0,
        user_status: USER_STATUSES_NAMES.FREE,
        user_turnover: 0,
        user_turnover_next: 0,
        user_turnover_percent: 0,
        username: '',
        verify: {},
        waiting_withdrawal: [],
    },
    usernameChange: {
        error: null,
        suggestion: null,
        updated: false
    },
    openedModal: null,
    openedModalPrevious: null,

    availableCountries: [],
    availableLocales: [
        { value: LOCALE_CODES.en, name: 'EN', fullName: 'English' },
    ],
    domainConfig: {
        appStoreLinkApple: '',
        appStoreLinkGoogle: '',
        appTitle: '',
        contactsEmail: '',
        privacyPolicyLink: '',
        clientAgreementLink: '',
        referralRules: '',
    },

    registration: null,
    changeEmail: false,
    codeChecked: false,
    isCheckCodeLoading: false,

    abTests: {},
    abTestsIsUsedQueue: [],

    isCreatePasswordLoading: false,
    isFirstLogin: false,

    features: {},
    partner: {},

    onboardingCompleted: false,
    onboardingCompleteLoading: false,
    accountsTradeInfo: {},

    selectedAccountCode: null,
    padVersion: null,

    isOpenMobileAppBannerVisible: true,
    announcement: null,
    askPhone: null,

    requestFeedback: false,
    requestFeedbackSent: false,
    requestFeedbackError: null,

    zendesk: {
        isInited: false,
        snippetKey: '',
        token: null,
        unreadMessagesCount: 0,
        widgetType: ZENDESK_WEB_WIDGET_TYPES.STANDARD,
    },
    ipcountry: '',

    isDeleteProfileLoading: false,
    deleteProfileError: null,

    contactsEmail: '',
    isOneClickTradingOn: false,
    isFirstDealDone: null,
};

const appReducer = (state: IAppState = initialState, action: IFullAppActyonTypes) =>
    produce(state, (draft: IAppState) => {
        switch (action.type) {

            case APP_INIT_START:
                draft.isInitLoading = true;
                break;

            case APP_INIT_SUCCESS:
            case APP_INIT_FAILURE:
                draft.isInitLoading = false;
                draft.inited = true;
                break;

            case SET_APP_INIT_DATA:
                draft.availableCountries = action.payload.availableCountries || [];
                draft.availableLocales = action.payload.availableLocales || draft.availableLocales;
                draft.domainConfig = action.payload.domainConfig;
                draft.loggedIn = !!action.payload.loggedIn;
                draft.user = action.payload.user || initialState.user;
                draft.passwordMinLength = action.payload.passwordMinLength;
                draft.abTests = action.payload.abTests;
                draft.onboardingCompleted = action.payload.onboardingCompleted;
                draft.features = action.payload.features || {};
                draft.padVersion = action.payload.v;
                draft.announcement = action.payload.announcement === undefined ? null : action.payload.announcement;
                draft.askPhone = action.payload.askPhone === undefined ? null : action.payload.askPhone;
                draft.requestFeedback = action.payload.requestFeedback;
                draft.zendesk = { ...draft.zendesk, ...action.payload.zendesk };
                draft.ipcountry = action.payload.ipcountry;
                draft.isFirstDealDone = action.payload.isFirstDealDone;
                break;

            case LOGIN_WITH_TELEGRAM_START:
                draft.loggedInProcess = true;
                break;
            case LOGIN_WITH_TELEGRAM_STOP:
                draft.loggedInProcess = false;
                break;

            case LOGIN_START:
                draft.formError = '';
                draft.loggedInProcess = true;
                break;

            case LOGIN_SUCCESS:
                draft.loggedIn = true;
                draft.loggedInProcess = false;
                break;

            case LOGIN_FAILURE:
                draft.formError = action.payload;
                draft.loggedInProcess = false;
                break;

            case REGISTRATION_PREPARE_MOBILE_ACTION:
            case REGISTRATION_START:
            case REGISTRATION_START_MOBILE_ACTION:
                draft.formError = '';
                draft.loggedInProcess = true;
                break;

            case REGISTRATION_SUCCESS:
                draft.registration = action.payload;
                draft.codeChecked = false;
                // draft.loggedInProcess = false;
                draft.isFirstLogin = true;
                break;

            case SET_REGISTRATION_DATA:
                draft.registration = action.payload;
                break;

            case REGISTRATION_FAILURE:
                draft.formError = action.payload;
                draft.changeEmail = true;
                draft.loggedInProcess = false;
                break;

            case PASSWORD_RESET_START:
                draft.formError = '';
                break;

            case PASSWORD_RESET_SUCCESS:
                draft.passwordResetSent = true;
                break;

            case PASSWORD_RESET_FAILURE:
                draft.passwordResetSent = false;
                draft.formError = action.payload;
                break;

            case PASSWORD_RESET_RESET:
                draft.passwordResetSent = false;
                break;

            case PASSWORD_UPDATE_START:
                draft.formError = '';
                break;

            case PASSWORD_UPDATE_SUCCESS:
                draft.loggedIn = true;
                break;

            case PASSWORD_UPDATE_FAILURE:
                draft.formError = action.payload;
                break;

            case SET_CHANGE_EMAIL_SUCCESS:
                draft.changeEmail = action.payload;
                break;

            case CHECK_CODE_START:
                draft.formError = null;
                draft.isCheckCodeLoading = true;
                break;

            case CHECK_CODE_SUCCESS:
                draft.codeChecked = true;
                draft.isCheckCodeLoading = false;
                break;

            case CHECK_CODE_FAILURE:
                draft.formError = action.payload;
                draft.isCheckCodeLoading = false;
                break;

            case CREATE_PASSWORD_START:
                draft.codeChecked = true;
                draft.formError = null;
                draft.isCreatePasswordLoading = true;
                break;

            case CREATE_PASSWORD_SUCCESS:
                draft.loggedIn = true;
                draft.isCreatePasswordLoading = false;
                break;

            case CREATE_PASSWORD_FAILURE:
                draft.formError = action.payload;
                draft.isCreatePasswordLoading = false;
                break;

            case USER_UPDATE_SUCCESS:
                draft.user = { ...draft.user, ...(action.payload || {}) };
                break;

            case USER_UPDATE_PASSWORD_START:
                draft.formError = null;
                break;

            case USER_UPDATE_PASSWORD_FAILURE:
                draft.formError = action.payload;
                break;

            case OPEN_MODAL:
                if (_.isObject(action.payload)) {
                    draft.openedModal = action.payload;
                } else {
                    draft.openedModal = {
                        name: action.payload,
                    };
                }
                break;

            case CLOSE_MODAL:
                draft.openedModalPrevious = Object.assign({}, draft.openedModal);
                draft.openedModal = null;
                break;

            case LOCATION_CHANGE:
                draft.requestFeedbackSent = false;
                draft.formError = '';
                break;

            case LOGOUT_SUCCESS:
                return {
                    ...initialState,
                    inited: true,
                    lang: state.lang,
                    availableCountries: state.availableCountries,
                    abTests: state.abTests,
                    domainConfig: state.domainConfig,
                    features: state.features,
                    zendesk: {
                        ...state.zendesk,
                        token: null,
                    }
                };

            case SET_IS_FIRST_LOGIN:
                draft.isFirstLogin = action.payload;
                break;

            case COMPLETE_ONBOARDING_START:
                draft.onboardingCompleteLoading = true;
                break;
            case COMPLETE_ONBOARDING_SUCCESS:
                draft.onboardingCompleteLoading = false;
                draft.onboardingCompleted = true;
                break;
            case COMPLETE_ONBOARDING_FAILURE:
                draft.onboardingCompleteLoading = false;
                break;

            case RESET_FORM_ERROR:
                draft.formError = '';
                break;

            case ADD_AB_TEST_TO_IS_USED_QUEUE:
                draft.abTestsIsUsedQueue.push(action.payload);
                break;
            case UPDATE_AB_TEST_IS_USED_START:
                draft.abTestsIsUsedQueue = [];
                action.payload.forEach(testName => {
                    if (draft.abTests[testName]) {
                        draft.abTests[testName].is_used = true;
                    }
                });
                break;
            case LOAD_ACCOUNT_TRADE_INFO_START:
                if (!draft.accountsTradeInfo[action.payload])
                    draft.accountsTradeInfo[action.payload] = {};
                draft.accountsTradeInfo[action.payload].isLoading = true;
                break;
            case LOAD_ACCOUNT_TRADE_INFO_SUCCESS:
                draft.accountsTradeInfo[action.payload.accountCode].isLoading = false;
                draft.accountsTradeInfo[action.payload.accountCode].data = action.payload.data;
                break;
            case LOAD_ACCOUNT_TRADE_INFO_FAILURE:
                draft.accountsTradeInfo[action.payload.accountCode].isLoading = false;
                break;

            case SET_USER_SELECTED_ACCOUNT_CODE:
                draft.selectedAccountCode = action.payload;
                break;

            case SET_IS_OPEN_MOBILE_APP_BANNER_VISIBLE:
                draft.isOpenMobileAppBannerVisible = action.payload;
                break;

            case 'VISIBILITY_CHANGE':
                draft.visibility = !document.hidden;
                break;

            case SET_LANG_DATA_ACTION:
                draft.lang = action.payload;
                break;

            case SET_REQUEST_FEEDBACK:
                draft.requestFeedback = true;
                break;
            case SEND_REQUEST_FEEDBACK_START:
                draft.requestFeedbackSent = true;
                draft.requestFeedback = false;
                break;
            case SEND_REQUEST_FEEDBACK_FAILURE:
                draft.requestFeedbackError = action.payload;
                break;

            case UPDATE_ACCOUNT_ACTION:
                draft.user.accounts = state.user.accounts.map(account => {
                    if (account.name === action.payload.name) {
                        return {
                            ...account,
                            ...action.payload
                        };
                    }
                    return account;
                });
                break;

            case SET_ZENDESK_CONFIG_ACTION:
                draft.zendesk = { ...draft.zendesk, ...action.payload };
                break;

            case DELETE_PROFILE_START:
                draft.isDeleteProfileLoading = true;
                draft.deleteProfileError = null;
                break;
            case DELETE_PROFILE_SUCCESS:
                draft.isDeleteProfileLoading = false;
                break;
            case DELETE_PROFILE_FAILURE:
                draft.isDeleteProfileLoading = false;
                draft.deleteProfileError = action.payload;
                break;
            case TOGGLE_IS_ONE_CLICK_TRADING_ON:
                draft.isOneClickTradingOn = !state.isOneClickTradingOn;
                break;
            case USER_UPDATE_USERNAME_START:
                draft.usernameChange = {
                    error: null,
                    suggestion: null,
                    updated: false
                }
                break;
            case USER_UPDATE_USERNAME_SUCCESS:
                let updatedUser = { ...draft.user, username: action.payload.username };

                draft.user = updatedUser;
                draft.usernameChange = {
                    ...draft.usernameChange,
                    updated: true
                }
                break;
            case USER_UPDATE_USERNAME_FAILURE:
                if (typeof action.payload === 'string') {
                    draft.usernameChange = {
                        ...draft.usernameChange,
                        error: action.payload,
                        updated: false
                    }
                } else {
                    const {
                        messageCode,
                        payload: payloadSuggestion
                    } = action.payload as IUsernameSuggestionFailurePayload;

                    draft.usernameChange = {
                        error: messageCode,
                        suggestion: payloadSuggestion.suggestion,
                        updated: false
                    }
                }
                break;
            case USER_UPDATE_USERNAME_CLEAR:
                draft.usernameChange = {
                    error: null,
                    suggestion: null,
                    updated: false
                }
                break;
            case COMPLETE_LEADERBOARD_ONBOARDING_SUCCESS:
                draft.user.leaderboardOnboardingPassed = true;
                break;

            default:
                return state;
        }
    });

export default appReducer;
